import { render, staticRenderFns } from "./TextMessageClient.vue?vue&type=template&id=b318bba0&scoped=true&lang=html"
import script from "./TextMessageClient.vue?vue&type=script&lang=js"
export * from "./TextMessageClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b318bba0",
  null
  
)

export default component.exports